export default {"src":"/_next/static/media/right-arrow.7af21c2c.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};